module.exports = __webpack_public_path__ + "static/media/achievement-game-master.6caca418.svg";